import React, { useEffect, useState } from "react";
import "./Home_SectionFive.scss";
import { getPopularWeek } from "../../../services/home/home";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";

function Home_SectionFive() {
  const [popularWeek, setPopularWeek] = useState([]);

  useEffect(() => {
    const fetchApi = async () => {
      const contentPopularWeek = await getPopularWeek();
      setPopularWeek(contentPopularWeek);
      //   console.log(contentPopularWeek);
    };
    fetchApi();
  }, []);

  return (
    <>
      <div className="home-sectionFive">
        <div className="container">
          <div className="home-sectionFive-wrapper">
            {popularWeek.length > 0 && (
              <React.Fragment>
                <div className="box-head">Phổ biến tuần này</div>

                <Row gutter={[20, 20]} className="popular-week">
                  {popularWeek.map((item) => (
                    <Col
                      key={item.id}
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={12}
                      sm={12}
                      xs={24}
                    >
                      <Link to="/products" className="popular-week-item">
                        <div className="inner-main">
                          <div className="img">
                            <img src={item.thumbnail} alt="Popular Week Img" />
                          </div>

                          <div className="title">{item.title}</div>
                          <div className="sub">
                            <span className="bold">{item.count_search}</span>{" "}
                            lượt tìm kiếm
                          </div>
                        </div>
                      </Link>
                    </Col>
                  ))}
                </Row>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Home_SectionFive;
